export const BASE_FIELD_PAGE = 'page';
export const BASE_FIELD_PAGE_COLLECTION = 'pageCollection';
